import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const FacetPriceContainer = styled("div")`
    width: 100%;
    overflow: hidden;
    margin: auto;
    padding: 2.25rem 2.25rem 1.25rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0 0.5rem;
    }
`

export default FacetPriceContainer
